/**
 * Environment configuration
 * This file centralizes all environment variable access and validation
 */

const PREFIX = 'VITE_';

export const ENV = {
  AIRTABLE_ACCESS_TOKEN: import.meta.env.VITE_AIRTABLE_ACCESS_TOKEN,
  AIRTABLE_OPERATIONS_BASE_ID: import.meta.env.VITE_AIRTABLE_OPERATIONS_BASE_ID,
  SITE_PASSWORD: import.meta.env.VITE_SITE_PASSWORD,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  SENTRY_RELEASE: import.meta.env.VITE_SENTRY_RELEASE,
  GA4_MEASUREMENT_ID: import.meta.env.VITE_GA4_MEASUREMENT_ID,
  ENABLE_ADMIN_FEATURES: import.meta.env.VITE_ENABLE_ADMIN_FEATURES
};

/**
 * Validates that all required environment variables are present
 * @throws {Error} If any required environment variables are missing
 */
export const validateEnv = () => {
  const required = [
    'AIRTABLE_ACCESS_TOKEN',
    'AIRTABLE_OPERATIONS_BASE_ID'
  ];

  const missing = required.filter(key => !ENV[key]);
  
  if (missing.length > 0) {
    const errorMessage = `Missing required environment variables:\n${
      missing.map(key => `  - ${PREFIX}${key}`).join('\n')
    }\n\nPlease ensure these variables are set in your Cloudflare Pages environment variables:\n1. Go to your Cloudflare Pages project\n2. Navigate to Settings > Environment variables\n3. Add the missing variables with your Airtable credentials`;
    
    console.error(errorMessage);
    throw new Error(errorMessage);
  }

  // Validate that the values are not empty strings
  const empty = required.filter(key => ENV[key] === '');
  if (empty.length > 0) {
    const errorMessage = `The following environment variables are empty:\n${
      empty.map(key => `  - ${PREFIX}${key}`).join('\n')
    }\n\nPlease ensure these variables have valid values in your Cloudflare Pages settings.`;
    
    console.error(errorMessage);
    throw new Error(errorMessage);
  }
};

// Development helper to check environment variables
if (import.meta.env.DEV) {
  console.log('Environment Variables Status:');
  Object.entries(ENV).forEach(([key, value]) => {
    // Don't log sensitive values, just show if they're set
    const isSensitive = ['AIRTABLE_ACCESS_TOKEN', 'SITE_PASSWORD', 'SENTRY_DSN', 'GA4_MEASUREMENT_ID'].includes(key);
    const displayValue = isSensitive && value ? '✓ Set (hidden)' : (value ? '✓ Set' : '✗ Missing');
    console.log(`  ${PREFIX}${key}: ${displayValue}`);
  });
}

export default ENV; 